import { render, staticRenderFns } from "./waterStat.vue?vue&type=template&id=4cab7cc8&scoped=true&"
import script from "./waterStat.vue?vue&type=script&lang=js&"
export * from "./waterStat.vue?vue&type=script&lang=js&"
import style0 from "./waterStat.vue?vue&type=style&index=0&id=4cab7cc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab7cc8",
  null
  
)

export default component.exports